import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=5ca8a04b&scoped=true"
import script from "./Filtro.vue?vue&type=script&lang=js"
export * from "./Filtro.vue?vue&type=script&lang=js"
import style0 from "./Filtro.vue?vue&type=style&index=0&id=5ca8a04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8a04b",
  null
  
)

export default component.exports